/* eslint-disable */
import { WebApi } from "@/services/WebApi"

const state = () => ({
    clientCardDetailsInviteCaches: []
})

const getters = {
    findClientCardDetailsInviteCache: (state) => (key) => {
        return state.clientCardDetailsInviteCaches.find(ccdic => ccdic.key === key);
    }
}

const mutations = {
    setClientCardDetailsInvites(state, { key, invite }) {
        const existing = state.clientCardDetailsInviteCaches.find(ccdic => ccdic.key === key);
        if (!!existing) {
            existing.value = invite;
            existing.loading = false;
        } else {
            state.clientCardDetailsInviteCaches.push({ key: key, value: invite, loading: false });
        }
    },
    setLoading(state, { key, loading }) {
        const existing = state.clientCardDetailsInviteCaches.find(ccdic => ccdic.key === key);
        if (!!existing) {
            existing.loading = !!loading;
            existing.retry = false;
        } else {
            state.clientCardDetailsInviteCaches.push({ key: key, value: null, loading: !!loading });
        }
    },
    setRetry(state, key) {
        const existing = state.clientCardDetailsInviteCaches.find(ccdic => ccdic.key === key);
        if (!!existing) {
            existing.retry = true;
            existing.loading = false;
        }
    },
    setUpdatedPet(state, { inviteId, petId }) {
        const invite = state.clientCardDetailsInviteCaches.find((ccdic) => ccdic.key === inviteId);
        if (invite) {
            if (!invite.value.updatedPets.includes(petId)) {
                invite.value.updatedPets.push(petId);
            }
        }
    },
    setUpdatedPetNote(state, { inviteId, petId }){
        const invite = state.clientCardDetailsInviteCaches.find((ccdic) => ccdic.key === inviteId);
        if (invite) {
            if (!invite.value.updatedPetNotes.includes(petId)) {
                invite.value.updatedPetNotes.push(petId);
            }
        }
    }
}

const actions = {
    fetchClientCardDetailsInvite({ commit }, inviteId) {
        return new Promise((resolve, reject) => {
            commit('setLoading', { key: inviteId, loading: true });
            WebApi.get('ClientCardDetailsInvite/' + inviteId)
                .then(response => {
                    commit('setClientCardDetailsInvites', { key: inviteId, invite: response.data });
                    resolve(response);
                })
                .catch(error => {
                    commit('setRetry', inviteId);
                    reject(error);
                });
        });
    },
    viewClientCardDetailsInvite({ commit }, inviteId) {
        return new Promise((resolve, reject) => {
            commit('setLoading', { key: inviteId, loading: true });
            WebApi.put('ClientCardDetailsInvite/' + inviteId + '/View')
                .then(response => {
                    commit('setClientCardDetailsInvites', { key: inviteId, invite: response.data });
                    resolve(response);
                })
                .catch(error => {
                    commit('setRetry', inviteId);
                    reject(error);
                });
        });
    },
    completeClientCardDetailsInvite({ commit }, inviteId) {
        return new Promise((resolve, reject) => {
            commit('setLoading', { key: inviteId, loading: true });
            WebApi.put('ClientCardDetailsInvite/' + inviteId + '/Complete')
                .then(response => {
                    commit('setClientCardDetailsInvites', { key: inviteId, invite: response.data });
                    resolve(response);
                })
                .catch(error => {
                    commit('setRetry', inviteId);
                    reject(error);
                });
        });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
